/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Settings_Teams_RenameInputs */

const cs_settings_teams_rename = /** @type {(inputs: Settings_Teams_RenameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Přejmenovat tým`)
};

const en_settings_teams_rename = /** @type {(inputs: Settings_Teams_RenameInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Rename team`)
};

/**
* | output |
* | --- |
* | "Rename team" |
*
* @param {Settings_Teams_RenameInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const settings_teams_rename = /** @type {((inputs?: Settings_Teams_RenameInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Settings_Teams_RenameInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_settings_teams_rename(inputs)
	return cs_settings_teams_rename(inputs)
});